import { styled } from "styled-components";

import Map from "components/Map";
import { Container as GridContainer } from "style/components/Page";

export const Container = styled(GridContainer)`
    height: min(calc(100vh - 3.125rem), 29.6875rem);
    max-width: none;
    padding-bottom: 0;
    padding-top: 0;
    position: relative;
`;

export const StyledMap = styled(Map)`
    inset: 0;
    position: absolute;
    z-index: 1;
`;
